module.exports = __webpack_public_path__ + "static/media/Event_Breakdown_1.a1b6435a.png";